<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
const styleMap = [{value: 1, name: '亮色', key: 'theme-light'},{value: 2, name: '暗色', key: 'theme-dark'}];
const colorMap = [{value: 1, name: '红色系', key: 'theme-red'},{value: 2, name: '蓝色系', key: 'theme-blue'}, {value: 3, name: '绿色系', key: 'theme-green'}];
export default {
  name: 'app',
  data(){
    return {
      themeColor: 'theme-blue',
      themeBrightness: 'theme-light'
    }
  },
  watch: {
    '$store.state.decoration'(newVal){
        if(newVal){
          this.setTheme(newVal);
        }
    }
  },
  methods: {
    /*
     *@description:'vux数据持久化'
     */
    vuexDataPersistence() {
      window.addEventListener('beforeunload', () => {
        localStorage.setItem('store', JSON.stringify(this.$store.state)); //将状态数据 存储到 sessionStorage中
      });
      try {
        this.$store.replaceState({
          ...this.$store.state,
          ...JSON.parse(localStorage.getItem('store') ?? {}),
        });
      } catch (err) {
        console.log('err:app', err);
      }

      localStorage.removeItem('store'); //移除store同步数据
    },

    /*
     *@description:'初始化权限 - 登录会会掉一次 ， 这个当方为了防止 非登录情况下 vuex 持久化 失效问题'
     */
    initUserOrPermission() {
      const token = localStorage.getItem('authToken') ?? null;
      if (token) {
        this.$store.dispatch('A_GET_USERINFO');
      }
      if (token) {
        //token  存在 并且用户信息 不存在 就调接口
        this.$store.dispatch('A_GET_PERMISSION_TREE');
      }
      if (token) {
        //token  存在 并且用户信息 不存在 就调接口
        this.$store.dispatch('A_GET_DECORATION')
      }
    },
    // 设置主题色
    setTheme(decoration) {
      const decorationColor = (location.hostname == 'vsp-jybs.jd.com'  ? 'theme-red' : 'theme-blue');
      document.querySelector('body').setAttribute('theme-color',(colorMap.find(v => decoration.decorationColor == v.value)?.key || decorationColor)); 
      document.querySelector('body').setAttribute('theme-style',(styleMap.find(v => decoration.decorationStyle == v.value)?.key || 'theme-light')); 
    }
  },

  created() {
    this.setTheme({});
    this.vuexDataPersistence();
    this.initUserOrPermission();
  },
};
</script>
<style scoped lang="scss">
#app {
  background-color: #f4f5f9;
}
.Zzindex {
  z-index: 999999 !important;
}
::v-deep .el-message-box__wrapper {
  z-index: 2004 !important;
}
</style>
